import React from 'react';
import ReferenceDF from '../components/SimulatorsComponents/DefualtSimulators/ReferenceDF';

//= ========================================================================

const Sim_F09_RequestPaymentReference = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <ReferenceDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_F09_RequestPaymentReference;
